export const validators = {
  backend: (fieldName, errors) => ({
    validator: async () => {
      if (errors && fieldName in errors) {
        return Promise.reject(new Error(errors[fieldName][0]));
      }
    },
  }),
};

export const checkPassword = ({ getFieldValue }) => ({
  validator(_, value) {
    if (!value || getFieldValue('password') === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('The two passwords that you entered do not match!'));
  },
});
